import { use } from 'react'

import { UserNavContext } from '#providers/UserNavProvider'
import type { IUserNavContext } from '#providers/UserNavProvider/interfaces'

export const useUserNav = (): IUserNavContext | null => {
  return use(UserNavContext)
}
